import ContactInitialState from './ContactInitialState'

import canReducer from './can/canContactReducer'
import formReducer from './form/contactFormReducer'
import roleReducer from './role/contactRoleReducer'
import communityReducer from './community/communityReducer'
import countReducer from './count/contactCountReducer'
import detailsReducer from './details/contactDetailsReducer'
import historyReducer from './history/contactHistoryReducer'
import organizationReducer from './organization/organizationReducer'

const initialState = new ContactInitialState()

export default function contactReducer(state = initialState, action) {
    let nextState = state

    const can = canReducer(state.can, action)
    if (can !== state.can) nextState = nextState.setIn(['can'], can)

    const form = formReducer(state.form, action)
    if (form !== state.form) nextState = nextState.setIn(['form'], form)

    const role = roleReducer(state.role, action)
    if (role !== state.role) nextState = nextState.setIn(['role'], role)

    const count = countReducer(state.count, action)
    if (count !== state.count) nextState = nextState.setIn(['count'], count)

    const details = detailsReducer(state.details, action)
    if (details !== state.details) nextState = nextState.setIn(['details'], details)

    const history = historyReducer(state.history, action)
    if (history !== state.history) nextState = nextState.setIn(['history'], history)

    const community = communityReducer(state.community, action)
    if (community !== state.community) nextState = nextState.setIn(['community'], community)
    
    const organization = organizationReducer(state.organization, action)
    if (organization !== state.organization) nextState = nextState.setIn(['organization'], organization)

    return nextState
}